import type { IMapTilesConfiguration } from "../../../commons/src/lib/models/interfaces/environment.interface";

export const MAP_TILES = {
  url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
} satisfies IMapTilesConfiguration;
